import React from 'react';
import logo from './img/logo_no_bg.png';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './footer.css';

function Footer() {
    return (
        <footer className="site-footer">

            <div className="site-footer__body">

                {/* LEFT */}
                <div className="footer-left">
                    <a href="/" className="footer-brand">
                        <img src={logo} alt="OctoNexus Power" className="footer-brand__logo" />
                        <span className="footer-brand__name">OctoNexus Power</span>
                    </a>

                    <div className="footer-social">
                        <a href="https://www.linkedin.com/company/octonexus-power" target="_blank" rel="noopener noreferrer" className="footer-social__icon" aria-label="LinkedIn">
                            <i className="bi bi-linkedin" />
                        </a>
                    </div>

                    <div className="footer-contact">
                        <p><span className="footer-contact__label">Email</span><a href="mailto:rigo.zom@octonexuspower.com">rigo.zom@octonexuspower.com</a></p>
                        <p><span className="footer-contact__label">Location</span>Kings Street, Aberdeen AB24 2BA, Scotland</p>
                        <p><span className="footer-contact__label">Website</span><a href="https://www.octonexuspower.com" target="_blank" rel="noopener noreferrer">www.octonexuspower.com</a></p>
                    </div>
                </div>

                <div className="footer-divider" />

                {/* MIDDLE */}
                <div className="footer-nav">
                    <div className="footer-col">
                        <h4 className="footer-col__heading">Company</h4>
                        <ul className="footer-col__list">
                            <li><a href="/about_us/who_we_are">Who We Are</a></li>
                            <li><a href="/about_us/our_mission">Our Mission</a></li>
                            <li><a href="/about_us/our_vision">Our Vision</a></li>
                            <li><a href="/about_us/our_core_values">Our Core Values</a></li>
                            <li><a href="/impact">Impact</a></li>
                            <li><a href="/careers">Careers</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4 className="footer-col__heading">Technology</h4>
                        <ul className="footer-col__list">
                            <li><a href="/ourtechnology/HydroVerra">HydroVerra</a></li>
                            <li><a href="/ourtechnology/HydraCell">HydraCell</a></li>
                            <li><a href="/ourtechnology/Zyraxon">Zyraxon</a></li>
                            <li><a href="/sectors">Sectors</a></li>
                            <li><a href="/impact">Impact</a></li>
                        </ul>
                    </div>
                </div>

                {/* RIGHT — CTA card */}
                <div className="footer-cta-card">
                    <p className="footer-cta-card__heading">
                        Start your <span className="footer-cta-card__accent">Zero Emission</span> Journey
                    </p>
                    <button className="footer-cta-card__btn footer-cta-card__btn--primary" onClick={() => window.location.href = '/contactus'} aria-label="Contact us to work with OctoNexus Power">
                        Work With Us
                    </button>
                    <button className="footer-cta-card__btn footer-cta-card__btn--outline" onClick={() => window.location.href = '/ourtechnology/HydroVerra'} aria-label="Explore HydroVerra hydrogen power technology">
                        Explore HydroVerra
                    </button>
                </div>

            </div>

            <div className="site-footer__bottom">
                <p className="footer-copy">© 2025 OctoNexus Power Ltd. All rights reserved.</p>
                <div className="footer-legal">
                    <a href="/terms" style={{ color: '#9ca3af', fontSize: '0.8rem', textDecoration: 'none' }} className="footer-legal__link">Terms &amp; Conditions</a>
                    <span className="footer-legal__dot" />
                    <a href="/privacy" style={{ color: '#9ca3af', fontSize: '0.8rem', textDecoration: 'none' }} className="footer-legal__link">Privacy Policy</a>
                </div>
            </div>

        </footer>
    );
}

export default Footer;
